import { FieldTypes, WellStratumFieldsEdit } from './../../../../types/form-types'
import { fractionDescriptors, FractionTypes } from './lithology-types'

type SetValue = (
  fieldId: keyof WellStratumFieldsEdit,
  value: FieldTypes,
  key?: string | undefined,
  index?: number | undefined,
) => void
// Return allowed attributes to display per fraction type
export const extractAllowableFields = (attribute?: string) => {
  if (!attribute) {
    return []
  }
  // https://stackoverflow.com/questions/43619955/regex-two-uppercase-characters-in-a-string
  return attribute?.match(/[A-Z][^A-Z]*[A-Z]/g)
}

export const stratumHasExistingFractionType = (
  fractionType: FractionTypes,
  stratum: Partial<WellStratumFieldsEdit>,
) => {
  if (`${fractionType}Fraction` in stratum) {
    const value = stratum[`${fractionType}Fraction` as keyof typeof stratum]
    if (Number(value) > 0) {
      return true
    }
  }
  return false
}

// Loop through the different fraction type descriptors keys and reset to ''
// Ensures that correct data sent to server and old data removed when fraction type changes
export const resetFractionTypeDescriptorFields = (
  fractionType: FractionTypes,
  value: string,
  stratum: Partial<WellStratumFieldsEdit>,
  setValue: SetValue,
) => {
  for (const descriptor of fractionDescriptors) {
    if (`${fractionType}${descriptor}` in stratum) {
      setValue(`${fractionType}${descriptor}` as keyof typeof stratum, value)
    }
  }
}
